module.exports = "precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nuniform vec2 px;\nvarying vec2 uv;\n\n\nvoid main(){\n    uv = vec2(0.5)+(position.xy)*0.5;\n    gl_Position = vec4(position, 1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/color.vert
// module id = 307
// module chunks = 0